import axios from "axios";
import enviroment from "../../../enviroments";
import { getCurrentToken } from "../../../hooks/useRefreshToken";

const whatsappApi = axios.create({
  baseURL: enviroment.BASE_URL || "/api",
  headers: { "Content-Type": "application/json" },
});

whatsappApi.interceptors.request.use((config) => {
  const token = getCurrentToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default whatsappApi;
